import { render, staticRenderFns } from "./EditEventTopicsModal.vue?vue&type=template&id=6818a2ef&"
import script from "./EditEventTopicsModal.vue?vue&type=script&lang=ts&"
export * from "./EditEventTopicsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports